import { type ReactElement } from 'react';
import { r, s } from '@/theme/tokens';
import { IconButton } from '@/ui/primitives';
import { KeyboardArrowRightOutlinedIcon } from '@/ui/primitives/icons';
import {
  tableV2ChevronColumnWidth,
  tableV2ChevronIconSize,
  tableV2ChevronOffsetTransform,
} from './TableV2Constants';

export const TableV2ChevronButton = ({
  expanded,
  label,
  onClick,
}: {
  expanded: boolean;
  label: string;
  onClick: () => void;
}): ReactElement => (
  <IconButton
    aria-label={label}
    aria-expanded={expanded}
    size="small"
    onClick={onClick}
    sx={{
      alignItems: 'center',
      borderRadius: r('pill'),
      color: 'text.primary',
      display: 'inline-flex',
      height: tableV2ChevronColumnWidth,
      justifyContent: 'center',
      left: '50%',
      lineHeight: 0,
      p: s('none'),
      position: 'absolute',
      top: '50%',
      transform: expanded
        ? `${tableV2ChevronOffsetTransform} rotate(90deg)`
        : `${tableV2ChevronOffsetTransform} rotate(0deg)`,
      transition: (theme) => theme.transitions.create('transform', { duration: 160 }),
      verticalAlign: 'middle',
      width: tableV2ChevronColumnWidth,
      '& .MuiSvgIcon-root': {
        fontSize: tableV2ChevronIconSize,
        height: tableV2ChevronIconSize,
        width: tableV2ChevronIconSize,
      },
    }}
  >
    <KeyboardArrowRightOutlinedIcon
      sx={{
        display: 'block',
      }}
    />
  </IconButton>
);
